import { render, staticRenderFns } from "./SendToRevisionDialog.vue?vue&type=template&id=3adc0a4d&"
import script from "./SendToRevisionDialog.vue?vue&type=script&lang=js&"
export * from "./SendToRevisionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports